import { z } from 'zod';

export const courseGameTypesScheme = z.object({
  holes: z.array(
    z.object({
      challengeConfigId: z.number().int().min(1).max(2147483647).nullable(),
    })
  ),
});

export type CourseGameTypesForm = z.infer<typeof courseGameTypesScheme>;
